import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

var POLL_INTERVAL = 3 * 60 * 1000; // 3 minutes

var bannerStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  zIndex: 99999,
  backgroundColor: '#2b2d42',
  color: '#fff',
  padding: '10px 20px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '14px',
  fontFamily: "'Source Sans Pro', sans-serif",
  boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
};

var btnStyle = {
  marginLeft: '14px',
  padding: '5px 18px',
  fontSize: '13px',
  fontWeight: 600,
  border: 'none',
  borderRadius: '4px',
  cursor: 'pointer',
  backgroundColor: '#fff',
  color: '#2b2d42',
  letterSpacing: '0.3px',
};

var dismissStyle = {
  marginLeft: '10px',
  background: 'none',
  border: 'none',
  color: '#8d99ae',
  cursor: 'pointer',
  fontSize: '18px',
  padding: '0 6px',
  lineHeight: 1,
};

class VersionChecker extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showBanner: false,
    };
    this.currentVersion = null;
    this.pollTimer = null;
  }

  componentDidMount() {
    this.fetchVersion(true);
    this.pollTimer = setInterval(this.checkVersion, POLL_INTERVAL);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      this.checkVersion();
    }
  }

  componentWillUnmount() {
    if (this.pollTimer) {
      clearInterval(this.pollTimer);
    }
  }

  fetchVersion = (isInitial) => {
    fetch('/version.json?t=' + Date.now())
      .then(function(res) { return res.json(); })
      .then(function(data) {
        if (data && data.version) {
          if (isInitial) {
            this.currentVersion = data.version;
          } else if (this.currentVersion && data.version !== this.currentVersion) {
            this.setState({ showBanner: true });
          }
        }
      }.bind(this))
      .catch(function() {});
  }

  checkVersion = () => {
    if (this.state.showBanner) return;
    this.fetchVersion(false);
  }

  handleRefresh = () => {
    window.location.reload(true);
  }

  handleDismiss = () => {
    this.setState({ showBanner: false });
  }

  render() {
    if (!this.state.showBanner) return null;

    return (
      <div style={bannerStyle}>
        <span>A new version of the dashboard is available.</span>
        <button style={btnStyle} onClick={this.handleRefresh}>
          Refresh Now
        </button>
        <button style={dismissStyle} onClick={this.handleDismiss} title="Dismiss">
          &times;
        </button>
      </div>
    );
  }
}

export default withRouter(VersionChecker);
